import { get, getById } from "@/utilities/querySelector";

class AccordionItemHTMLElement extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();
    }

    connectedCallback() {
        const toggler = this.querySelector( 'button' );
        toggler?.addEventListener( 'click', this.toggle.bind( this ) );
    }

    disconnectedCallback() {

    }

    toggle() {
        const siblings = this.closest( 'section, .section' )?.querySelectorAll( 'accordion-item' );
        siblings?.forEach( sibling => {
            if ( sibling !== this ) sibling.removeAttribute( 'open' );
        } );
        this.toggleAttribute( 'open' );

        if (window.innerWidth <= 768 && this.hasAttribute('open')) {
            const headerHeight = getById('site-header').offsetHeight;
            setTimeout(() => {
                window.scrollTo({
                    top: this.offsetTop - (headerHeight + 20),
                    behavior: 'smooth'
                });
            }, 300);
        }
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback( name, oldVal, newVal ) {
        switch ( name ) {
            case 'open':
                break;
        }
    }
}

customElements.define( 'accordion-item', AccordionItemHTMLElement );